import { Component, OnInit, HostListener } from '@angular/core';

import { Setting } from '../../../models/setting';
import { SettingGroup } from '../../../models/setting-group';

import { AlertService } from '../../../services/common/alert.service';
import { SettingService } from '../../../services/settings/setting.service';
import { SettingGroupService } from '../../../services/settings/setting-group.service';

declare var swal: any;

@Component({
  selector: 'app-setting-index',
  templateUrl: './setting-index.component.html',
  styleUrls: ['./setting-index.component.css'],
})
export class SettingIndexComponent implements OnInit {
  settings: Array<any> = [];
  settingGroups: Array<SettingGroup> = [];
  addingSetting: boolean = false;
  newSetting: Setting = new Setting();
  editingSettings: any = {};
  selectedSettingGroupId: number;

  constructor(private alertService: AlertService, private settingService: SettingService, private settingGroupService: SettingGroupService) {
    this.settingGroupService.getSettingGroups({}).then((response_json) => {
      this.settingGroups = response_json;
      if (this.settingGroups.length > 0) {
        this.selectedSettingGroupId = this.settingGroups[0].id;
        this.getSettings();
      }
    });
  }

  ngOnInit() {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  getSettings() {
    this.settingService
      .getSettings({
        setting_group_id: this.selectedSettingGroupId,
      })
      .then((response) => (this.settings = response));
  }

  onSettingFormEvent(formResult: string, setting: any = null) {
    switch (formResult) {
      case 'Form Cancelled':
        if (setting) this.editingSettings[setting.id] = false;
        else {
          this.addingSetting = false;
          this.newSetting = new Setting();
        }
        break;
      case 'Setting Group created':
        this.addingSetting = false;
        this.newSetting = new Setting();
        this.settingService
          .getSettings({
            setting_group_id: this.selectedSettingGroupId,
          })
          .then((response_json) => {
            this.settings = response_json;
          });
        break;
      case 'Setting Group updated':
        if (setting) {
          this.editingSettings[setting.id] = false;
          this.settingService
            .getSettings({
              setting_group_id: this.selectedSettingGroupId,
            })
            .then((response_json) => {
              this.settings = response_json;
            });
        }
        break;
    }
  }

  deleteSetting(setting: any) {
    let scope: SettingIndexComponent = this;
    swal({
      title: 'Delete setting',
      text: `Delete: ${setting.setting_type.name} - ${setting.value} ?`,
      icon: 'warning',
      dangerMode: true,
      buttons: {
        cancel: {
          text: 'No',
          value: false,
          visible: true,
          className: '',
          closeModal: true,
        },
        confirm: {
          text: 'Yes',
          value: true,
          visible: true,
          className: '',
          closeModal: true,
        },
      },
    })
      .then((confirmed: any) => {
        if (confirmed)
          this.settingService
            .deleteSetting(setting.id)
            .then((response) => {
              if (response && response.text) {
                this.alertService.alert_status_success(response.text);
                this.settingService.getSettings({}).then((response_json) => {
                  this.settings = response_json;
                });
              } else {
                this.alertService.alert_status_danger('Error deleting setting group');
              }
            })
            .catch(() => {
              scope.alertService.alert_status_danger('Error deleting setting group');
            });
      })
      .catch((err: any) => {
        console.log('Setting prompt error', err);
      });
  }

  toggleForm() {
    this.addingSetting = !this.addingSetting;
    this.newSetting = new Setting();
  }

  content_sidebar_scroll() {
    var content_main = document.getElementById('content_main');
    var content_sidebar = document.getElementById('content_sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 40;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 40;
        //console.log('lesser ' + matter_sidebar.style.top);
      }
      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }

  search_height_maintainer() {
    var content_sidebar = document.getElementById('content_sidebar');
    var content_search = document.getElementById('search_form');
    if (content_sidebar && content_search) {
      var search_height = content_sidebar.clientHeight - 195;
      if (search_height > 0) content_search.style.height = search_height + 'px';
      else content_search.style.height = '0px';
    }
  }
}
